// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Revoke } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDatevRevoke(): () => Promise<Revoke> {
  const getAPI = useGetApi();
  return useCallback(
    async () => (await getAPI()).externesysteme.datevRevoke(),
    [getAPI]
  );
}
